import API from "./api";

/**
 * Autocomplete class that shows address autocompletion. Its uses the API class to search and retrieve address information.
 */
class Autocomplete {
	/**
	 * Autocomplete class constructor
	 *
	 * @param {HTMLElement} container
	 * @param {HTMLElement} addressLine1Input
	 * @param {Object} selectors
	 */
	constructor(container, addressLine1Input, selectors) {
		this.container = container;
		this.addressLine1Input = addressLine1Input;
		this.selectors = selectors;
	}

	/**
	 * Initialise the autocomplete field
	 */
	init() {
		const _this = this;

		//Ensure that the container and address line 1 input elements exist in the DOM
		if (this.container === null || this.addressLine1Input === null) {
			return;
		}

		API.init();

		const $addressLine1Input = jQuery(this.addressLine1Input);
		const $container = jQuery(this.container);

		const close = function () {
			$addressLine1Input.autocomplete("close");
		};

		//Attach the jQuery autocomplete field to the address line 1 input
		$addressLine1Input.autocomplete({
			html: true,
			minLength: 8,
			source: function (request, response) {
				API.searchAddress(request.term).then(function (data) {
					let results = [];

					if (data.DtResponse.Result.length > 0) {
						results = data.DtResponse.Result.map(function (item) {
							let Output = (item.AddressLine + ", " + item.Locality + ", " + item.State + ", " + item.Postcode);
							return {
								label: Output,
								value: Output,
								address: item,
							};
						});
					}

					results.push({
						label: "<b>Don't see your address?</b> Search again or <span class=\"manual-entry\">enter an address manually</span>.",
						value: "dont_see_address"
					});

					response(results);
				}, () => close);
			},

			select: function (event, ui) {
				event.preventDefault();

				const updateValue = function ($element, value) {
					if ($element.length > 0) {
						$element.val(value);
						$element[0].dispatchEvent(new Event('change'));
					}
				};

				const updateAddressField = (selectors, value) => {
					if (!Array.isArray(selectors)) {
						selectors = [selectors];
					}
					selectors.forEach(selector => {
						const $element = $container.find(selector);
						if ($element.length) {
							updateValue($element, value);
						}
					});
				};

				if (ui.item.value === 'dont_see_address') {
					$addressLine1Input.autocomplete("close");
					updateValue($addressLine1Input, "");
					return;
				}

				API.retrieveAddress(ui.item.address.RecordId).then((data) => {
					const address = API.formatAddress(data);

					const mappings = [
						{
							selector: _this.selectors.AddressLine1,
							value: address.AddressLine1,
						},
						{
							selector: _this.selectors.AddressLine2,
							value: address.AddressLine2,
						},
						{
							selector: _this.selectors.City,
							value: address.City,
						},
						{
							selector: _this.selectors.State,
							value: address.State,
						},
						{
							selector: _this.selectors.Postcode,
							value: address.Postcode,
						},
					];

					mappings.forEach(mapping => updateAddressField(mapping.selector, mapping.value));
				}, () => close);
			}
		});
	}
}

export default Autocomplete;
